import DateFnsUtils from "@date-io/date-fns";
import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiThemeProvider } from "@material-ui/core/styles";
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import isEmpty from "ramda/src/isEmpty";
import React from "react";
import { queryCache, useQuery } from "react-query";
import { ReactQueryDevtools } from "react-query-devtools";

import { QUERY_AUTH } from "../services/auth/queries";
import { STORAGE_KEYS } from "../utils/constants";
import Routes from "./Routes";
import { theme } from "./theme";

const App = () => {
  const { data: user, error, refetch: authUser } = useQuery(QUERY_AUTH);
  const isAuthenticated = !isEmpty(user);

  if (localStorage[STORAGE_KEYS.AUTH_TOKEN]) {
    if (error) {
      queryCache.removeQueries(QUERY_AUTH.queryKey);
      localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
    }

    if (!isAuthenticated) {
      authUser();
      return <div />;
    }
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Routes />
      </MuiThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </MuiPickersUtilsProvider>
  );
};

export default App;
